import { gql } from "@apollo/client";

export const SIGN_IN = gql`
  mutation userSignIn($data: Auth0SignInInput!) {
    signIn(
      data: $data
    ) {
      access_token,
      token_type,
      expires_in,
      scope,
      id_token,
      custom_token
    }
  }`;
